<div class="grid-container padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">FRT BILL OF LADING</legend>
  </div>
  <form [formGroup]="frtBolForm">
    <div class="grid-row grid-gap-1" id="BOLInformation">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="drnSuffix" class="usa-label  text-bold">Book Shipment Id</label>
        <label class="usa-label">{{bookShipmentId}}</label>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="bolNo" class="usa-label  text-bold">Bill of Lading No.</label>
        <label for="bolNo" class="usa-label">{{bolInfo ? bolInfo.bolNumber : ''}}</label>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="dateBLIssues" class="usa-label  text-bold">Date BL Issued</label>
        <label for="dateBLIssues" class="usa-label">{{(bolInfo ? bolInfo.creationDate : '') | date:'MM/dd/yyyy'}}</label>
      </div>
    </div>
    <div class="padding-y-4">
      <div class="usa-accordion usa-accordion--bordered">
        <h4 class="usa-accordion__heading">
          <button class="usa-accordion__button" aria-expanded="false" aria-controls="TSPandFurnished">
            TSP & Furnished Information On Shipments
          </button>
        </h4>
        <div id="TSPandFurnished" class="usa-accordion__content usa-prose">
          <app-frt-billoflading-information [shipmentDetailsInfo]="shipmentDetailsInfo" [carrier]="carrier" [shipmentsInfo]="shipmentsInfo" [sealNos]="sealNos" [purchaseOrders]="purchaseOrders" [ratesFrtInfo]="ratesFrtInfo" [shipperInfo]="shipperInfo" [agencyInfo]="agencyInfo"
            [carrierOrganizationInfo]="carrierOrganizationInfo" [shipmentCostInfo]="shipmentCostInfo" [bookshipmentInfo]="bookshipmentInfo" [isOneTimeShipment]="isOneTimeShipment" [rateTypesInfo]="rateTypesInfo" [shipmentInfoIdFromUrl]="shipmentInfoIdFromUrl">
          </app-frt-billoflading-information>
        </div>

        <h4 class="usa-accordion__heading">
          <button class="usa-accordion__button" aria-expanded="false" aria-controls="ShipmentInformation">
            Shipment Information
          </button>
        </h4>
        @if (shipmentDetailsId) {
          <div id="ShipmentInformation" class="usa-accordion__content usa-prose">
            <app-frt-shipment-package-info-modal [frtPackageDetailsCalledFrom]="'frtBOL'" [shipmentDetailsIdFromFrtBol]="shipmentDetailsId">
            </app-frt-shipment-package-info-modal>
          </div>
        }

        <h4 class="usa-accordion__heading">
          <button class="usa-accordion__button" aria-expanded="false" aria-controls="AccessorialInformation">
            Accessorial Information
          </button>
        </h4>
        @if (shipmentInfoIdFromUrl) {
          <div id="AccessorialInformation" class="usa-accordion__content usa-prose">
            <app-frt-shipment-accessorials [accessorialsCalledFrom]="'bol'" [shipmentInfoIdFromUrl]="shipmentInfoIdFromUrl">
            </app-frt-shipment-accessorials>
          </div>
        }

        <h4 class="usa-accordion__heading">
          <button class="usa-accordion__button" aria-expanded="false" aria-controls="FRTBOL">
            FRT Bill Of Lading Finalization
          </button>
        </h4>
        <div id="FRTBOL" class="usa-accordion__content usa-prose">
          <app-frt-billoflading-finalization [totalCost]="totalCost" [additionalRemarks]="additionalRemarks" [billOfLadingNbr]="billOfLadingNbr" formControlName="billOfLadingShipmentFinalization">
          </app-frt-billoflading-finalization>
        </div>

      </div>
    </div>
    <div class="grid-row grid-gap-1">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <!--add a if check, make it true when BOL is not generated-->
        <button type="button" class="usa-button" (click)="saveBillOfLadingDetails()">Save</button>
        @if (this.billOfLadingNbr == null || this.billOfLadingNbr == '') {
          <button type="button" class="usa-button margin-left-2" (click)="generateBillOfLadingPDF('previewFRT')">Preview Bill Of Lading</button>
        }
        @if (this.billOfLadingNbr == null || this.billOfLadingNbr == '') {
          <button type="button" class="usa-button margin-left-2" (click)="generateBillOfLadingPDF('generateFRT')">Generate Bill Of Lading</button>
        }
        @if (this.billOfLadingNbr != null && this.billOfLadingNbr != '') {
          <button class="usa-button margin-left-2" (click)="generateFRTCorrectionNoticePDF()">
            Generate Correction Notice
          </button>
        }
        <button type="button" class="usa-button usa-button--outline margin-left-2" (click)="backToOnlineBooking()">Back to
        Book Shipments</button>
      </div>
    </div>
  </form>
</div>
